/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_StarInputs */

const en_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Star`)
};

const fr_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favori`)
};

const de_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stern`)
};

const it_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stella`)
};

const ru_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Звезда`)
};

const es_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrella`)
};

const zh_cn2_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星星`)
};

const ja_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星`)
};

const hi_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारा`)
};

const pt_pt2_explorer_info_property_star = /** @type {(inputs: Explorer_Info_Property_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrela`)
};

/**
* | output |
* | --- |
* | "Star" |
*
* @param {Explorer_Info_Property_StarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_star = /** @type {((inputs?: Explorer_Info_Property_StarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_StarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_star(inputs)
	if (locale === "de") return de_explorer_info_property_star(inputs)
	if (locale === "it") return it_explorer_info_property_star(inputs)
	if (locale === "ru") return ru_explorer_info_property_star(inputs)
	if (locale === "es") return es_explorer_info_property_star(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_star(inputs)
	if (locale === "ja") return ja_explorer_info_property_star(inputs)
	if (locale === "hi") return hi_explorer_info_property_star(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_star(inputs)
	return en_explorer_info_property_star(inputs)
});